module.exports = __webpack_public_path__ + "static/media/22ESCWA7.9f9100e9.jpg";